import React from 'react';
import { formatRecordAudit } from '../../utils/helpers';

const RecordAuditBlock = ({ record }) => {
  const audit = formatRecordAudit(record || {});
  return (
    <div className="text-sm space-y-1 pt-3 mt-3 border-t border-gray-100">
      <p><span className="text-gray-500">La galiyay:</span> {audit.createdAtLabel}</p>
      <p><span className="text-gray-500">User:</span> {audit.createdBy}</p>
      {audit.updatedAtLabel !== audit.createdAtLabel && audit.updatedAtLabel !== '-' && (
        <>
          <p><span className="text-gray-500">La cusboonaysiiyay:</span> {audit.updatedAtLabel}</p>
          <p><span className="text-gray-500">User:</span> {audit.updatedBy}</p>
        </>
      )}
    </div>
  );
};

export default RecordAuditBlock;
